export default "/fonts/nexa-light.2bac835e8aabddeb710cb1bf9b39c0ed.otf";